import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../store';

export const selectPictures = (state: RootState) => state.pictures;
export const selectEmojis = createSelector(
  selectPictures,
  (pictures) => pictures.emojis
);
